module.exports = __webpack_public_path__ + "static/img/Round-22-2016.0575d96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-22-2016.jpg
// module id = Ksfo
// module chunks = 0